module.exports = __webpack_public_path__ + "img/video.319ae4fb.svg";